import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './InvestorWithoutPan/contributor';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                RM/Distributor Details
              </Typography>
            </Grid>

            <Gridstyles sx={{ width: '100%' }}>
              <Grid
                item
                container
                pt={1}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                {application.distributor_id ? (
                  <>
                    <KeyValue
                      title={'Distributor Name'}
                      description={application?.distributor?.name || 'NA'}
                    />
                    <KeyValue
                      title={'Distributor Code'}
                      description={application?.distributor?.arnCode || 'NA'}
                    />
                    {application?.subdistributorId && (
                      <>
                        <KeyValue
                          title={'Distributor RM Name'}
                          description={application?.subDistributor?.user?.firstName || 'NA'}
                        />
                        <KeyValue
                          title={'Distributor RM Code'}
                          description={application?.subDistributor?.distributors_RM_Code || 'NA'}
                        />
                        <KeyValue
                          title={'Distributor RM Email Id'}
                          description={application?.subDistributor?.user?.email || 'NA'}
                        />
                      </>
                    )}
                    {!application?.subdistributorId && (
                      <KeyValue
                        title={'Distributor Email Id'}
                        description={application?.distributor?.user?.email || 'NA'}
                      />
                    )}
                    {application?.supportSubdistributor?.user?.id && (
                      <>
                        <KeyValue
                          title={'CSE Name'}
                          description={application?.supportSubdistributor?.user?.firstName || 'NA'}
                        />
                        <KeyValue
                          title={'CSE Email'}
                          description={application?.supportSubdistributor?.user?.email || 'NA'}
                        />
                        <KeyValue
                          title={'CSE Code'}
                          description={
                            application?.supportSubdistributor?.distributors_RM_Code || 'NA'
                          }
                        />
                      </>
                    )}
                  </>
                ) : null}
                {application?.rmName && (
                  <KeyValue title={'Marcellus RM Name'} description={application?.rmName || 'NA'} />
                )}
                <KeyValue
                  title={'AMC RM Email Id'}
                  description={application?.rm?.user?.email || 'NA'}
                />
              </Grid>
            </Gridstyles>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
